import { MockRestCall } from "@/common/api/ApiResult.model";
import { SharedState } from "@/common/state";
import { rand_floor } from "@/fp";
import { RestCallsKey } from "../demo/rest.resolver";

const INFO_TYPES = [
  ["Customers & Suppliers", "a29e3cf4-4e86-6972-e9b6-efa700189e40"],
  ["Invoices, Receipts & Bills", "0df478c4-00e1-0f5f-cea2-889498c15c50"],
  ["Purchase Orders", "f1c9f6ba-07ee-ea53-c2df-6b8a65821a2d"],
  ["Work Plans", "ed0e56fa-5e68-a340-9952-4f9ffa0af841"],
  ["Financial Reports & Planning", "948be2bd-6558-f72a-adb7-ef3ca00fc76c"],
  ["Budgets", "3228aae1-97c1-a84f-9746-c2e688ba6163"],
  ["Cost Reports", "6c8a992b-3758-4731-9f24-ae64317a9929"],
  ["Employee Cost Report", "a2d288be-6e34-f599-564b-63bf66da3c63"],
  ["Salaries", "21029718-e0c3-ed47-35cd-6f05f26d8b90"],
  ["Incentive Bonuses", "ae6c88fe-6fb5-87de-541a-84ad159d7ed6"],
  ["Time Sheets", "c8b225b1-05bc-9c5b-2a60-bc6e9b8d4c04"],
  ["Warning Letters", "bbe64b61-f177-fc48-6884-4756c28d1637"],
  ["Disciplinary Hearing Minutes", "5690b04c-100d-7cef-b712-f6732464bf1b"],
  ["Appointments & Promotions", "a4d462b4-4037-4f42-143e-e5d491ca12ef"],
  ["Employee Retention Agreements", "f2c5b4b2-a9ef-0a10-804f-692cd330fc6f"],
  ["Employment Contract Extensions", "4e62a7cc-5544-d432-4c8e-4d7bba308c38"],
  ["Stay Interviews", "4841c565-c14d-e9bd-2ee2-946a85324a40"],
  ["Employment Termination", "566ea101-ba77-bf1f-3dfd-7425b036dd92"],
  ["Dismissal Letters", "2e5fe6b2-e12c-d475-bec8-dc7c5ed99961"],
  ["Employee Absence Follow Up", "f922d38f-072f-7412-fdb9-c5e660d4a940"],
  ["External Learning Requests", "83b357ff-5a3d-4d87-3a4a-bcc3f05479f2"],
  ["Leaves of Absence", "54473915-9d62-a9b8-fca5-cc5ad4ac6174"],
  ["Vacation Requests", "9ca2acd5-c8f1-31a0-c3bc-13233b3db220"],
  ["Recruitment", "9bfe32ca-663a-cef7-2234-e9fd7594faad"],
  ["CVs", "4fab503f-4528-6291-e667-db29d8c7011f"],
  ["Employment Offers", "e8d9a74f-b479-9032-0522-039048857bcf"],
  ["Job Applications", "1cfa5663-a692-42ce-6ec5-d6f811d03d3a"],
  ["Job Descriptions", "ec754340-8c3f-3efd-473f-a250c4221799"],
  ["Job Interviews", "e67d194b-abcd-a8ca-51e5-bdb38f738bf7"],
  ["Manager Recruitment Requests", "880e3e14-e745-4b7c-d7da-bb39dcc3d452"],
  ["Agreements", "d1f5dcf3-4b72-b411-4a0f-5a2d3fda400d"],
  ["Addendums & Appendixes", "12c44622-b8f5-0220-4d61-06c1e41c8871"],
  ["Administration Agreements", "986525bc-2d8c-5451-a6c3-e11dc7d76451"],
  ["Collaboration Agreements", "3d044ca7-0885-df96-666d-399451886d12"],
  ["Collective Labor Agreements", "561b5f77-d5dd-5fbd-91dc-e517b005b1ce"],
  ["Confidentiality & NDA Agreements", "6f5b15d9-08a7-cc0d-6cee-596892ea0697"],
  ["Contract Amendments", "8d8c483d-f07f-567e-32be-165cd187f30e"],
  ["Side Letters", "d29b2b78-72cc-b7a0-72db-08d58017888c"],
  ["Guides", "a7b9e7f1-8761-08b3-d3cc-2b61cb46a4b7"],
  ["Customers and Suppliers", "5e7d363a-905a-4827-a2aa-de652418c6a7"],
  ["Employee Expenses", "6c530c03-db0f-4a0d-be85-666b8d3bf88b"],
  ["Accounting", "6dcf508e-8050-44a5-9227-b677f2d07699"],
  ["Financial Reports and Planning", "99b9124d-d62a-4d76-bf45-abfc5b987081"],
];

const to_sensitivity_type_name = {
  Internal: "Internal Confidential",
  External: "Customer Confidential",
  Both: "Confidential",
};

// @ts-ignore
export const info_motion: Record<Partial<RestCallsKey>, MockRestCall> = {
  "info-motion.by-departments.list": {
    delay: 0,
    payload: async () => {
      const { SharedState } = await import("@/common/state");
      return {
        cursor: "",
        objects: INFO_TYPES.filter(
          ([, id]) => SharedState.allInfoTypes.value[id]
        ).map(([name, id]) => {
          const the_label = SharedState.allInfoTypes.value[id];
          return {
            id: id,
            label: {
              id: id,
              name: name,
              sensitivity: the_label.sensitivity,
              sensitivityTypeName:
                to_sensitivity_type_name[the_label.sensitivityType],
            },
            departments: rand_floor(20),
            organizations: rand_floor(10),
          };
        }),

        /* Array(20)
          .fill({})
          .map((_, index) => {
            return {
              id: index,
              label: {
                id: index,
                name: "label_name_" + index,
                sensitivity: 2,
                sensitivityTypeName: "Internal Confidential",
              },
              departments: 20,
              organizations: 20,
            };
          }), */
      };
    },
  },
  "info-motion.by-info-types.list": {
    delay: 0,
    payload: async () => {
      return {
        cursor: "",
        objects: Object.entries(SharedState.departments.value).map(
          ([id, department]) => {
            return {
              id,
              department,
              people_count: SharedState.departments_people_count.value[id],
              departments: Math.floor(Math.random() * 10),
              organizations: Math.floor(Math.random() * 10),
            };
          }
        ) /* Array(20)
          .fill({})
          .map((_, index) => {
            return {
              id: index,
              department: "Department of " + index,
              people_count: 20,
              departments: 20,
              organizations: 20,
            };
          }) */,
      };
    },
  },
};
